import { CabinClassRequest } from '@clients/FlightApi';
import { type TripPackageLoaderConfig } from '@itinerary/trip/types';

export enum FlightStatus {
    Ok = 'Ok',
    Delayed = 'Delayed',
    Cancelled = 'Cancelled',
}

export enum CabinClassRequestPersian {
    All = 'همه‌ی کلاس‌های نرخی',
    Economy = 'اکونومی',
    Business = 'بیزینس',
    FirstClass = 'فرست کلاس',
    Unknown = 'ناشناس',
    EconomyPlus = 'اکونومی پلاس',
}

export const CabinClasses = EnumClass.mergeEnums(
    CabinClassRequest,
    CabinClassRequestPersian
);

export interface FlightPackageLoaderConfig extends TripPackageLoaderConfig {
    adultCount: number;
    childCount: number;
    infantCount: number;
    cabinClass?: CabinClassRequest;
    returnDate?: Date;
    isRealTime?: boolean;
    isCapacityTrackCampaign?: boolean;
    token?: string;
    xplayerID?: string;
}
